
import Teleport from 'vue2-teleport';
import * as Sentry from '@sentry/vue';
import { Dialog, useDialogStore } from '@/features/dialog/composables/useDialogStore'
import BaseDialog from '@/features/dialog/components/BaseDialog.vue'
import { defineComponent } from 'vue';


export default defineComponent({
  name: 'DialogController',
  components: {
    BaseDialog,
    Teleport,
  },
  setup() {
    const { dialogs, closeTopDialog } = useDialogStore()

    // If a dialog listener throws, force-close the dialog instead of leaving
    // its overlay stuck on top of the app (blocking all clicks) forever.
    const wrapListeners = (dialog: Dialog) => {
      const wrapped: Record<string, (...args: any[]) => void> = {}
      for (const [event, handler] of Object.entries(dialog.listeners ?? {})) {
        const fns = Array.isArray(handler) ? handler : [handler]
        wrapped[event] = (...args: any[]) => {
          void (async () => {
            try {
              await Promise.all(fns.map(fn => fn(...args)))
            } catch (e) {
              Sentry.captureException(e)
              closeTopDialog()
            }
          })();
        }
      }
      return wrapped
    }

    return {
      dialogs,
      closeTopDialog,
      wrapListeners,
    }
  },
})
